// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Playlists_container__ueIAr {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #121212;
  color: #ffffff;
  padding-top: 5rem !important;
}

.Playlists_title__gxO1m {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 24px;
  color: #ff3b30; /* Red accent color */
}

.Playlists_typeSection__-M5zl {
  margin-bottom: 32px;
}

.Playlists_typeTitle__EcoEh {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #ff3b30; /* Red accent color */
  border-bottom: 2px solid #ff3b30;
  padding-bottom: 8px;
  display: inline-block;
}

/* Enhanced Swiper styling */
.Playlists_swiper__pY2dy {
  width: 100%;
  padding: 10px 0 30px 0;
}

/* Card image container for better control */
.Playlists_imageContainer__Rf\\+oE {
  position: relative;
  width: 100%;
}

/* Responsive settings */
@media (max-width: 480px) {
  .Playlists_container__ueIAr {
    max-width: 95%;
    margin: 0 auto;
  }
  
}

.Playlists_card__CB0QR {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #1e1e1e; /* Dark card background */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #333;
  cursor: pointer;
}

/* Only apply hover effects on non-mobile devices */
@media (min-width: 768px) {
  .Playlists_card__CB0QR:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
    border-color: #ff3b30; /* Red border on hover */
  }
  
  .Playlists_card__CB0QR:hover .Playlists_playButton__OWAa\\+ {
    opacity: 1;
  }
  
  .Playlists_card__CB0QR:hover .Playlists_removeButton__bJ-9C:not(.Playlists_alwaysShow__6FUoZ) {
    opacity: 1;
  }
}

/* Mobile card specific styles */
.Playlists_mobileCard__apO9- {
  transform: none;
  transition: none;
}

.Playlists_cardImage__P7Lav {
  width: 100%;
  object-fit: cover;
}

.Playlists_cardTitle__pTIdZ {
  padding: 12px;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.3;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #f0f0f0; /* Light text for contrast */
}

.Playlists_removeButton__bJ-9C {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(255, 59, 48, 0.7); /* Semi-transparent red */
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
}

/* Always show remove button on mobile */
.Playlists_alwaysShow__6FUoZ {
  opacity: 1;
}

.Playlists_removeButton__bJ-9C:hover {
  background-color: #ff3b30; /* Solid red on hover */
}

.Playlists_playButton__OWAa\\+ {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 59, 48, 0.7); /* Semi-transparent red */
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 1;
}

.Playlists_playButton__OWAa\\+:hover {
  background-color: #ff3b30; /* Solid red on hover */
  transform: translate(-50%, -50%) scale(1.1);
}

.Playlists_loading__Ilh0T, .Playlists_error__VdpNQ, .Playlists_empty__3PUiZ {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
  text-align: center;
  font-size: 1.2rem;
  color: #f0f0f0;
  background-color: #1e1e1e;
  border-radius: 8px;
  margin-top: 20px;
}

.Playlists_loadMoreBtn__B-epL {
  display: block;
  margin: 20px auto;
  padding: 10px 24px;
  background-color: #ff3b30; /* Red button */
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.Playlists_loadMoreBtn__B-epL:disabled {
  background-color: #555;
  cursor: not-allowed;
}

.Playlists_loadMoreBtn__B-epL:hover:not(:disabled) {
  background-color: #ff1a0d; /* Brighter red on hover */
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 59, 48, 0.4);
  max-height: 190px;
}
@media (max-width: 480px) {
  .Playlists_cardImage__P7Lav {
    min-height: 130px;
  }
  .Playlists_swiper__pY2dy {
    padding: 10px 0 30px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/settings-pages/Playlists.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,qBAAqB;EACrC,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE;IACE,cAAc;IACd,cAAc;EAChB;;AAEF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAE,yBAAyB;EACpD,wCAAwC;EACxC,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE;IACE,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB,EAAE,wBAAwB;EACjD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc,EAAE,4BAA4B;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wCAAwC,EAAE,yBAAyB;EACnE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC,EAAE,yBAAyB;EACnE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB,EAAE,eAAe;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #121212;\n  color: #ffffff;\n  padding-top: 5rem !important;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 24px;\n  color: #ff3b30; /* Red accent color */\n}\n\n.typeSection {\n  margin-bottom: 32px;\n}\n\n.typeTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: #ff3b30; /* Red accent color */\n  border-bottom: 2px solid #ff3b30;\n  padding-bottom: 8px;\n  display: inline-block;\n}\n\n/* Enhanced Swiper styling */\n.swiper {\n  width: 100%;\n  padding: 10px 0 30px 0;\n}\n\n/* Card image container for better control */\n.imageContainer {\n  position: relative;\n  width: 100%;\n}\n\n/* Responsive settings */\n@media (max-width: 480px) {\n  .container {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  \n}\n\n.card {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #1e1e1e; /* Dark card background */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #333;\n  cursor: pointer;\n}\n\n/* Only apply hover effects on non-mobile devices */\n@media (min-width: 768px) {\n  .card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);\n    border-color: #ff3b30; /* Red border on hover */\n  }\n  \n  .card:hover .playButton {\n    opacity: 1;\n  }\n  \n  .card:hover .removeButton:not(.alwaysShow) {\n    opacity: 1;\n  }\n}\n\n/* Mobile card specific styles */\n.mobileCard {\n  transform: none;\n  transition: none;\n}\n\n.cardImage {\n  width: 100%;\n  object-fit: cover;\n}\n\n.cardTitle {\n  padding: 12px;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.3;\n  flex-grow: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: #f0f0f0; /* Light text for contrast */\n}\n\n.removeButton {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: rgba(255, 59, 48, 0.7); /* Semi-transparent red */\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 2;\n}\n\n/* Always show remove button on mobile */\n.alwaysShow {\n  opacity: 1;\n}\n\n.removeButton:hover {\n  background-color: #ff3b30; /* Solid red on hover */\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(255, 59, 48, 0.7); /* Semi-transparent red */\n  color: white;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 1;\n}\n\n.playButton:hover {\n  background-color: #ff3b30; /* Solid red on hover */\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.loading, .error, .empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  width: 100%;\n  text-align: center;\n  font-size: 1.2rem;\n  color: #f0f0f0;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.loadMoreBtn {\n  display: block;\n  margin: 20px auto;\n  padding: 10px 24px;\n  background-color: #ff3b30; /* Red button */\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.loadMoreBtn:disabled {\n  background-color: #555;\n  cursor: not-allowed;\n}\n\n.loadMoreBtn:hover:not(:disabled) {\n  background-color: #ff1a0d; /* Brighter red on hover */\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(255, 59, 48, 0.4);\n  max-height: 190px;\n}\n@media (max-width: 480px) {\n  .cardImage {\n    min-height: 130px;\n  }\n  .swiper {\n    padding: 10px 0 30px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Playlists_container__ueIAr`,
	"title": `Playlists_title__gxO1m`,
	"typeSection": `Playlists_typeSection__-M5zl`,
	"typeTitle": `Playlists_typeTitle__EcoEh`,
	"swiper": `Playlists_swiper__pY2dy`,
	"imageContainer": `Playlists_imageContainer__Rf+oE`,
	"card": `Playlists_card__CB0QR`,
	"playButton": `Playlists_playButton__OWAa+`,
	"removeButton": `Playlists_removeButton__bJ-9C`,
	"alwaysShow": `Playlists_alwaysShow__6FUoZ`,
	"mobileCard": `Playlists_mobileCard__apO9-`,
	"cardImage": `Playlists_cardImage__P7Lav`,
	"cardTitle": `Playlists_cardTitle__pTIdZ`,
	"loading": `Playlists_loading__Ilh0T`,
	"error": `Playlists_error__VdpNQ`,
	"empty": `Playlists_empty__3PUiZ`,
	"loadMoreBtn": `Playlists_loadMoreBtn__B-epL`
};
export default ___CSS_LOADER_EXPORT___;
